import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home_cat_buttons1" }
const _hoisted_2 = ["href", "target", "onMouseover", "onMouseleave"]
const _hoisted_3 = { class: "text1" }
const _hoisted_4 = { class: "text1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconMenuListData, (button) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: button.menuId
      }, [
        (button.linkURL.startsWith('http'))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: button.linkURL,
              target: button.isSaparateTab ? '_blank' : '_self',
              class: _normalizeClass(['button1', { hover: button.hover }]),
              onMouseover: ($event: any) => (button.hover = true),
              onMouseleave: ($event: any) => (button.hover = false)
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(['image1', button.hover ? 'hover' : '']),
                style: _normalizeStyle({
            backgroundImage: `url(${_ctx.appDir}/images/${
              button.hover ? button.imageFileOver : button.imageFileNomal
            })`,
            backgroundColor: '#F3F5F9',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            transition: '0.5s ease',
            transform: button.hover ? 'scale(1.05)' : 'scale(1)',
          })
              }, null, 6),
              _createElementVNode("span", _hoisted_3, _toDisplayString(button.menuName), 1)
            ], 42, _hoisted_2))
          : (_openBlock(), _createBlock(_component_router_link, {
              to: button.linkURL,
              key: button.menuId,
              target: button.isSaparateTab ? '_blank' : '_self',
              class: _normalizeClass(['button1', { hover: button.hover }]),
              onMouseover: ($event: any) => (button.hover = true),
              onMouseleave: ($event: any) => (button.hover = false)
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass(['image1', button.hover ? 'hover' : '']),
                  style: _normalizeStyle({
            backgroundImage: `url(${_ctx.appDir}/images/${
              button.hover ? button.imageFileOver : button.imageFileNomal
            })`,
            backgroundColor: '#F3F5F9', // 背景色
            backgroundPosition: 'center', // 画像を中央に配置
            backgroundSize: 'cover', // 画像をカバーとして設定
            transition: '0.5s ease',
            transform: button.hover ? 'scale(1.05)' : 'scale(1)', // ホバー時にスケールを変更
          })
                }, null, 6),
                _createElementVNode("span", _hoisted_4, _toDisplayString(button.menuName), 1)
              ]),
              _: 2
            }, 1032, ["to", "target", "class", "onMouseover", "onMouseleave"]))
      ], 64))
    }), 128))
  ]))
}